module.exports = __webpack_public_path__ + "img/c5f27cb.jpg";